import { swiffyslider } from 'swiffy-slider';
import classnames from 'classnames';
import React, { useRef, useCallback, useEffect } from 'react';

var classes = {"slider":"index-module_slider__7H1hz","indicator-container":"index-module_indicator-container__nF-6f","show-buttons":"index-module_show-buttons__6Rg4Q","hide-buttons":"index-module_hide-buttons__BGzHG"};

// Taken from the Swiffy documentation site
const getVisibleSlides = (sliderElement) => {
    const container = sliderElement.querySelector('.slider-container');
    if (container) {
        //We are using a grid layout and the slides left and right properties include the width of the gap, so when comparing with container width add a gap for each side of the slide gap.
        const gapWidth = Number.parseInt(window.getComputedStyle(container).columnGap);
        const slides = Array.from(container.children);
        return slides.find((slide) => {
            const slideScrollLeftPosition = slide.getBoundingClientRect().left -
                container.getBoundingClientRect().left;
            const slideScrollRightPosition = slideScrollLeftPosition + slide.offsetWidth - gapWidth;
            return (slideScrollLeftPosition >= 0 &&
                slideScrollRightPosition <= container.offsetWidth);
        });
    }
};
const Swiffy = ({ listItems, onChange, currentIndex, onError, showButtons, overlayElement, cssClass, labelArrows, }) => {
    const swiffyInstance = useRef(null);
    const onSlideChange = useCallback(() => {
        if (swiffyInstance.current) {
            try {
                const swiffyDom = swiffyInstance.current;
                const slides = getVisibleSlides(swiffyDom);
                const indexFromDataset = slides?.dataset['index'];
                if (indexFromDataset) {
                    const index = Number.parseInt(indexFromDataset);
                    onChange?.(index);
                }
            }
            catch (e) {
                console.error(e);
                onError?.(e, { note: 'Error in Swiffy component.' });
            }
        }
    }, [onChange, onError]);
    //On change listener:
    useEffect(() => {
        if (swiffyInstance.current) {
            const swiffyDom = swiffyInstance.current;
            swiffyslider.onSlideEnd(swiffyDom, onSlideChange);
        }
    }, [onSlideChange]);
    //Init library:
    useEffect(() => {
        if (swiffyInstance.current) {
            const swiffyDom = swiffyInstance.current;
            swiffyslider.initSlider(swiffyDom);
        }
    }, []);
    //Slide to implementation using prop
    useEffect(() => {
        if (swiffyInstance.current) {
            swiffyslider.slideTo(swiffyInstance.current, currentIndex);
        }
    }, [currentIndex]);
    return (React.createElement("div", { className: classnames('swiffy-slider', classes.slider, 'slider-nav-touch', 'slider-nav-visibile', cssClass), ref: swiffyInstance },
        React.createElement("ul", { className: "slider-container" }, listItems),
        overlayElement,
        React.createElement("div", { id: "buttons-container", className: listItems.length > 1 && showButtons
                ? classes['show-buttons']
                : classes['hide-buttons'] },
            React.createElement("button", { type: "button", className: "slider-nav", "aria-label": labelArrows.left }),
            React.createElement("button", { type: "button", className: "slider-nav slider-nav-next", "aria-label": labelArrows.right }))));
};

export { Swiffy as Carousel };
//# sourceMappingURL=index.js.map
